import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import {tableHideDetails} from "../../../../../@signals";
import { dsColorNew } from "@palette"
import { compareTooltips } from "Pages/AnalyzersV2/@services/passCompare"

export default function PriceContent(
	{
		price,
		prevPrice,
		evolutionChange,
		evolutionDiff,
		currency = '',
		// Analyzers that always want the bare price say so instead of relying on the
		// shared details toggle, which any toolbar can flip.
		compact = false,
		// a repricing pass: the earlier pass this cell compares with (CU-869fmm944); none with a report
		previousPass = null,
	}) {
	const tooltips = compareTooltips(previousPass)
	const priceColor = dsColorNew.textDark
	const onlyPrice = compact || tableHideDetails.value
	const evolutionIcons = {
		increase: { color: dsColorNew.successText, icon: "arrow-up" },
		decrease: { color: dsColorNew.dangerRed, icon: "arrow-down" },
		equal: { icon: "equals" },
	}
	const PriceDisplay = ({ value, color }) => <Typography variant="subtitle1" color={color} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
		{!!value ? `${value}` : 'N/A'}
		{!currency && <IconSeeker icon="star" sx={{ color: dsColorNew.noteAmber }}/>}
	</Typography>


	return <Grid container>
		<Grid item xs={(!evolutionChange && !prevPrice || onlyPrice) ? 12 : 6} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<TooltipSeeker title="Current Price">
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<PriceDisplay value={price} color={priceColor}/>
				</Box>
			</TooltipSeeker>
		</Grid>
		{!onlyPrice && (
			<Grid item xs={6} sx={{ visibility: !evolutionChange ? 'hidden' : ''  }}>
				<TooltipSeeker title={tooltips.diff} componentsProps={{ sx: { display: "flex" } }}>
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: .5 }}>
						<IconSeeker {...evolutionIcons[evolutionChange]} sx={{ mt: .2 }}/>
						<Typography variant="body2">{evolutionDiff || 0}%</Typography>
					</Box>
				</TooltipSeeker>
			</Grid>
		)}
		{!onlyPrice && (
			<Grid item xs={6} sx={{ display: "flex", alignItems: "center", justifyContent: "center", visibility: !prevPrice ? 'hidden' : ''  }}>
				<TooltipSeeker title={tooltips.previous}>
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
						<PriceDisplay value={prevPrice || 0} color={dsColorNew.textMuted}/>
					</Box>
				</TooltipSeeker>
			</Grid>
		)}
	</Grid>
}
